import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotSeparator = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	style: { display: "inline" },
	width: 4,
	height: 5,
	viewBox: "0 0 4 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("circle", {
		cx: 2,
		cy: 2.5,
		r: 2,
		fill: "#A9A9A9"
	})]
});
const ForwardRef = forwardRef(SvgDotSeparator);
export { ForwardRef as ReactComponent };
